import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './components/Home';
import Gallery from './components/Gallery';
import About from './components/About';
import Courses from './components/Courses';
import GurukulOffers from './components/GurukulOffers';
import Webinar from './components/Webinar';
import Contact from './components/Contact';

import Whatsapp from './components/Whatsapp';

function App() {
  return (

    <>

      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/about" element={<About />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/offerings" element={<GurukulOffers />} />
        <Route path="/Webinars" element={<Webinar />} />
        <Route path="/Contact-Us" element={<Contact />} />
      </Routes>


      <Whatsapp />

      <Footer />

    </>

  );
}

export default App;
